import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist/index.js';
import { UpdateType, } from '@debbie/common/dist/updates/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import * as connect from '@debbie/cortex/dist/api/connect.js';
import * as updatesLib from '@debbie/cortex/dist/api/updates.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { SITE } from '@debbie/cortex/dist/config.js';
import { useConnectCaseMapping } from '@debbie/cortex/dist/connect/index.js';
import { Button, ButtonGroup, DateInput, Modal } from '../index.js';
import Play from '../Icons/Play.js';
import X from '../Icons/X.js';
import TaskButtons from './TaskButtons.js';
import { Clock } from '../Icons/index.js';
import THEME from '../../theme.js';
import q from '@debbie/cortex/dist/query.js';
import { updatesEntity } from '@debbie/cortex/dist/updates/index.js';
const CasePauseActions = (props) => {
    const lang = useSelector((s) => s.lang);
    const [loadingContinue, setLoadingContinue] = useState(false);
    const [patchUpdateOpen, setPatchModalOpen] = useState(false);
    const [remindedAt, setRemindedAt] = useState(props.update.remindedAt ? moment(props.update.remindedAt) : null);
    const [loadingRemind, setLoadingRemind] = useState(false);
    const { singleCase, futurePause, update, updateType, canContinueCase, stack, isAwaitingClient, nextTask, } = props;
    const continueButton = futurePause || !updateType.pausing;
    const continueCase = async (id, updateId) => {
        try {
            setLoadingContinue(true);
            await updatesLib.patch(updateId);
            await c.cases.getUpdates(singleCase.caseId);
            q.invalidate(keys.write.modify(updatesEntity, updateId));
        }
        catch (e) {
            console.error(e);
            alert(e);
        }
        setLoadingContinue(false);
    };
    const authToken = useSelector(selectAuthToken);
    const [loadingCreditorLink, setLoadingCreditorLink] = useState(false);
    if (update.updateTypeId === UpdateType.SentToConnectPartner &&
        update.data != null &&
        update.data.mappingId != null) {
        const mappingId = update.data.mappingId;
        const mapping = useConnectCaseMapping(mappingId);
        return (React.createElement(React.Fragment, null,
            React.createElement(Button, { blockOnMobile: true, theme: "secondary", disabled: h.isError(mapping), onClick: () => {
                    if (h.hasData(mapping)) {
                        c.redirect.redirect(`/connect/connections/${mapping.data.connectConnectionId}`);
                    }
                } }, lang.connect.goToConnection),
            React.createElement(Button, { blockOnMobile: true, onClick: async () => {
                    try {
                        setLoadingCreditorLink(true);
                        const res = await connect.getMappingCreditorLink(mappingId);
                        window.location.href = res.link + `&authToken=${authToken}`;
                    }
                    catch (err) {
                        alert(lang.connect.creditorWebLinkError);
                    }
                    finally {
                        setLoadingCreditorLink(false);
                    }
                }, loading: loadingCreditorLink, disabled: loadingCreditorLink }, lang.connect.goToCreditorWeb)));
    }
    const saveRemindedAt = async (date) => {
        setLoadingRemind(true);
        try {
            stack.forEach(async (stackItem) => {
                await updatesLib.patch(stackItem.update.updateId, {
                    remindedAt: date?.toISOString(),
                });
            });
            await c.cases.getUpdates(singleCase.caseId);
            await setPatchModalOpen(false);
        }
        catch (error) {
            alert(error);
            console.error(error);
        }
        setLoadingRemind(false);
    };
    return (React.createElement(React.Fragment, null,
        nextTask &&
            // @ts-ignore
            nextTask.manual &&
            // @ts-ignore
            nextTask.tasks &&
            nextTask.pastUpdate?.updateId === update.updateId &&
            // @ts-ignore
            !!nextTask.tasks.length ? (
        // @ts-ignore
        React.createElement(TaskButtons, { tasks: nextTask.tasks, case: singleCase })) : canContinueCase ? (React.createElement(ButtonGroup, null,
            React.createElement(Button, { blockOnMobile: true, theme: "secondary", size: "small", onClick: async () => {
                    setPatchModalOpen(!patchUpdateOpen);
                } },
                React.createElement(Clock, { style: { margin: '.1em 0 -.2em' } })),
            React.createElement(Button, { blockOnMobile: true, loading: loadingContinue, theme: continueButton ? 'secondary' : 'warning', size: "small", onClick: () => {
                    stack.forEach((stackItem) => {
                        continueCase(singleCase.id, stackItem.update.updateId);
                        props.setDeletingUpdate(stackItem.update.updateId, true);
                    });
                } },
                continueButton ? (React.createElement(X, { style: { margin: '.1em 0 -.2em' } })) : (React.createElement(Play, { style: { margin: '0.1em 0 -.2em' } })),
                ' ',
                continueButton
                    ? lang.updates.continueCaseRemove
                    : lang.updates.continueCase))) : ((Site.Caseworker === SITE ||
            (isAwaitingClient && Site.Client == SITE)) && (React.createElement(X, { style: {
                margin: '0.55em 0',
                cursor: 'pointer',
            }, onClick: () => {
                continueCase(singleCase.id, update.updateId);
                props.setDeletingUpdate(update.updateId, true);
            } }))),
        patchUpdateOpen && (React.createElement("div", { style: { color: 'initial' } },
            React.createElement(Modal, { header: lang.updates.setRemindedAt, onToggle: () => setPatchModalOpen(!patchUpdateOpen), maxWidth: "300px" },
                React.createElement(DateInput, { placeholder: lang.updates.remindDate, onChange: (d) => {
                        setRemindedAt(d);
                        if (d) {
                            saveRemindedAt(d);
                        }
                    }, value: remindedAt, allowNull: true }),
                React.createElement(Button, { block: true, loading: loadingRemind, disabled: !remindedAt, onClick: () => {
                        if (remindedAt) {
                            saveRemindedAt(remindedAt);
                        }
                    } },
                    lang.updates.remindDate,
                    ' ',
                    remindedAt?.format(THEME.DATE_FORMAT_SHORT)))))));
};
export default CasePauseActions;
//# sourceMappingURL=CasePauseActions.js.map